import useSWR from "swr"

export const useEmployees = () => useSWR("/employees")

export const useGallery = id => useSWR(`/gallery/${id}`)
